export default __webpack_public_path__ + "static/screenshot_7-704ae68b434b9f15ab14ad7f29714f0e.png";